export const OUTLINE_BUILDER_GAMING = {
  name: "Maximizing Revenue from Hiring",
  prompt: "Who should I focus on hiring to maximize my revenue?",
  plan_description:
    "Let's help the user by first asking our Document Summary: Gaming Category Revenue Report which category has the highest revenue. " +
    "Then we can help assist the user in managing hiring these employees by find the number of possible candidates using our LinkedIn dataset, " +
    " as well as their salaries. " +
    "Finally we can build an Action Tree to help assist drafting possible emails.",
  generate_steps: [
    {
      type: "Document Summary",
      gen_prompt: "Let's find the gaming category with the highest revenue.",
      artifactId: 1612
    },
    {
      type: "NLQ",
      gen_prompt: "Calculate the number of possible candidates from the first step's output",
      datasetId: 578
    },
    {
      type: "NLQ",
      gen_prompt: "Calculate the average salary of candidates from the first step's output",
      datasetId: 578
    },
    {
      type: "Just Chat",
      gen_prompt: "Let's summarize what we know from the previous steps"
    },
    {
      type: "Action Tree",
      gen_prompt: "Generate 4 different common email requests from our previous steps output"
    }
  ]
};

export const FULL_BUILDER_GAMING = {
  name: "LinkedIn Demo",
  isAibleAgent: true,
  defaultPrompt: "Who should I focus on hiring to maximize my revenue?",
  prompt: "Who should I focus on hiring to maximize my revenue?",
  plan_description:
    "Let's help the user by first asking our Gaming Category Revenue Report which category has the highest revenue. " +
    "Then we can find the number of possible candidates using our LinkedIn dataset, as well as their salaries. " +
    "Finally we can build an Action Tree to help assist drafting possible emails.",
  steps: [
    {
      Title: "(Document Summary) - Find best category",
      Type: "Document Summary",
      Plan: "Let's find the gaming category with the highest revenue.",
      Prompt: "What is the gaming category with the highest revenue.",
      ArtifactId: 1612
    },
    {
      Title: "(NLQ) - Calculate candidates",
      Type: "NLQ",
      Plan: "Calculate the number of possible candidates from the first step's output",
      Prompt: "Calculate the number of possible candidates that can work in {{step_1.output}}",
      DatasetId: 7840
    },
    {
      Title: "(NLQ) - Calculate salary",
      Type: "NLQ",
      Plan: "Calculate the average salary of candidates from the first step's output.",
      Prompt: "Calculate the average salary of candidates in {{step_1.output}}",
      DatasetId: 7840
    },
    {
      Title: "(Just Chat) - What we know",
      Type: "Just Chat",
      Plan: "Let's summarize what we know from the previous steps.",
      Prompt:
        "Let's summarize what we know from {{step_1.output}}, " +
        "number of possible candidates: {{step_2.output}}, and the average salary: {{step_3.output}}."
    },
    {
      Title: "(Analytics) - How sales impacted by month",
      Type: "Analytics",
      Plan: "Find how our sales are impacted by month",
      Prompt: "How are my sales impacted by month?",
      DatasetId: 566
    },
    {
      Title: "(Prediction) - Find best month for sales",
      Type: "Prediction",
      Plan: "Let's find the best month for sales.",
      Prompt: "What is the best month for sales.",
      ProjectId: 766
    },
    {
      Title: "(Action Tree) - Further Actions",
      Type: "Action Tree",
      Plan: "Generate 2 different common email requests from our previous steps output.",
      Prompt:
        "Generate 2 different common email requests about hiring people using what we know from {{step_4.output}}",
      Actions: [
        {
          Text: "Send out a recruitment email",
          Prompt_Append:
            "\nLet's draft what a recruitment email might look like if we were to send it out to candidates"
        },
        {
          Text: "Email summary to HR",
          Prompt_Append: "\nLet's send an email to our HR department telling them what we found."
        }
      ]
    }
  ]
};

/*
export const FULL_BUILDER_ANDREW = {
	name: "Pricing Demo",
	defaultPrompt:
		"West Region would like to purchase 10 Live Free for their Direct Mail campaign",
	steps: [
		{
			Title: "Intent JSON",
			Type: "Just Chat",
			DatasetId: 578,
			Prompt:
				"Take the following User Prompt as well as a list of Dataset Fields, and give me back a raw JSON object with keys" +
				" 'intent', and other other's that match from the Dataset fields that are included in the User Prompt. " +
				"You should also have a ‘quantity’ field if the user has " +
				"a quantity in the prompt. The response must be only JSON, no additional markdown or text.",
		},
		{
			Title: "Calculate Price",
			DatasetId: 7841,
			Type: "NLQ",
			Prompt:
				"Calculate a total order value by searching for the unit price that matches " +
				"{{parsedFields_1.field}} {{parsedFields_1.value}} and multiplying by" +
				" the order quantity: {{parsedFields_1.quantity}}",
		},
		{
			Title: "Calculate Quantity",
			DatasetId: 7841,
			Type: "NLQ",
			Prompt:
				"Get the quantity in stock for {{parsedFields_1.field}} {{parsedFields_1.value}}. Show the number in stock and " +
				"indicate whether there are sufficient" +
				" to cover an order of {{parsedFields_1.quantity}} items.",
		},
		{
			Title: "Credit Risk",
			Type: "Analytics",
			DatasetId: 580,
			Prompt:
				"I'm going to be buying {{step_2.stock}} of this {{parsedFields_1.field}} {{parsedFields_1.value}} in the " +
				"{{parsedFields_0.value}} {{parsedFields_0.field}} " +
				"for ${{step_1.total_order_value}}, do you know anything interesting about this?",
		},
		{
			Title: "How would you like to proceed?",
			Type: "Action Tree",
			Prompt:
				"Draft an email for the person running the Direct Mail Campaign, " +
				"thanking them for their enquiry for {{parsedFields_1.quantity}} {{parsedFields_1.value}} for their " +
				"{{parsedFields_0.value}} {{parsedFields_0.field}}.",
			Actions: [
				{
					Text: "Prepare a quote for the items",
					Prompt_Append:
						"\nInclude a quote of ${{step_1.total_order_value}} and tell them the " +
						"shipper will be {{step_4.best}}. Payment terms are 60 days.",
				},
				{
					Text: "Decline to quote due to credit risk",
					Prompt_Append:
						"\nPolitely decline to quote for the items on the grounds that they are a credit risk.",
				},
				{
					Text: "Warn of low stock",
					Prompt_Append:
						"\nAdvise them that the items are likely to be delivered a little late and ask if they would like to proceed anyway.",
				},
				{
					Text: "Warn of possible late delivery",
					Prompt_Append:
						"\nAdvise them that the items are out of stock and ask if they would like to proceed with a delayed delivery.",
				},
			],
		},
	],
};
*/

export const EXAMPLE_INTENT_GAMING = {
  parsedFields: [{ field: "Skill", value: "Live Servies", datasetId: 7840 }]
};

export const EXAMPLE_DATASETS_GAMING = [
  {
    name: "test_linkedin_larger.csv",
    datasetId: 7840,
    fields: ["Name", "Skill", "Secondary_Skill", "Region", "Current_Company", "Estimated_Salary"]
  },
  {
    name: "my_product_stock.csv",
    datasetId: 7841,
    fields: ["product", "stock", "unit_price"]
  },
  {
    name: "Gaming Category Revenue Report",
    artifactId: 1612
  }
];
